<template>
    <div id="driver_commission_policies_layout">
        <div
            is="ErrorBox"
            :errors="errors"
        >
        </div>
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>
    </div>
</template>

<script>
import ErrorBox from '../.components/errors.vue'
export default {
    name: "DriverCommissionPoliciesLayout",
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    watch: {
    },
    created() {
        this.init()
    },
    mounted() {

    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            this.$noty.information(
                this.$t("ui.page_titles.driver_commission_policies") + ' ' +
                this.$t('ui.general.initialize_complete')
            , 300)
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
        ErrorBox,
    }
}
</script>
